export default __webpack_public_path__ + "static/media/recwave.1aa624c6.svg";